
export default function without<T>(
    dict: { [key: string]: T }, 
    keyToRemove: string
) {
    const { [keyToRemove]: removed, ...remaining } = dict 
    return remaining
}
